import React from 'react'
import { Center, Loader } from '@mantine/core'

export const CenteredLoader: React.FC = () => {
  return (
    <Center style={{ height: '100vh' }}>
      <Loader size="xl" />
    </Center>
  )
}
